import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="Más testimonios" className="bg-warm" data-id="element-135" data-mp="20fowudtw93h2">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "11px"
    }} data-id="element-136" data-mp="25a2ukmw13mow">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-137" data-mp="2a732l3cfuzin">
          Atletas que ya están utilizando este sistema
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-138" data-mp="1hjpdtsiw9a9m">
          {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.05} data-id="element-139" data-mp="1mgz1b2mq3but" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}